/* Clutch cart drawer: discount code apply/remove. Uses event delegation because the drawer HTML is re-rendered on every cart change. */
(function () {
  if (window.__clutchCartInit) return;
  window.__clutchCartInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setMsg(text, kind) {
    var el = document.getElementById('ClutchDiscountMsg');
    if (!el) return;
    el.textContent = text || '';
    el.classList.remove('is-error', 'is-ok');
    if (kind) el.classList.add('is-' + kind);
  }

  function currentCodes() {
    return Array.prototype.map.call(document.querySelectorAll('[data-clutch-remove]'), function (b) {
      return b.getAttribute('data-clutch-remove');
    });
  }

  function rerender(sections) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ id: null, sections: sections });
    }
  }

  function updateDiscounts(codes) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(','), sections: ['cart-drawer', 'cart-icon-bubble'] })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart update failed');
      return r.json();
    });
  }

  function apply(code) {
    var btn = document.querySelector('[data-clutch-apply]');
    if (btn) btn.disabled = true;
    setMsg('Applying…');
    var codes = currentCodes().filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
    codes.push(code);

    updateDiscounts(codes).then(function (cart) {
      if (!('discount_codes' in cart)) {
        // Store doesn't support codes in the cart API: save the code for checkout instead.
        return fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).then(function () {
          setMsg('Code ' + code + ' saved – it will be applied at checkout.', 'ok');
        });
      }
      var match = (cart.discount_codes || []).filter(function (d) {
        return (d.code || '').toUpperCase() === code.toUpperCase();
      })[0];
      if (match && match.applicable) {
        rerender(cart.sections);
        setMsg('Code ' + match.code + ' applied.', 'ok');
      } else {
        // Remove the invalid code again so it doesn't sit in the cart.
        var keep = codes.filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
        return updateDiscounts(keep).then(function (cart2) {
          rerender(cart2.sections);
          setMsg('That code isn’t valid for the items in your cart.', 'error');
        });
      }
    }).catch(function () {
      setMsg('Something went wrong. You can also enter the code at checkout.', 'error');
    }).finally(function () {
      var b = document.querySelector('[data-clutch-apply]');
      if (b) b.disabled = false;
    });
  }

  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest('[data-clutch-apply]');
    if (applyBtn) {
      e.preventDefault();
      var input = document.getElementById('ClutchDiscountInput');
      var code = input ? input.value.trim() : '';
      if (!code) { setMsg('Enter a discount code first.', 'error'); return; }
      apply(code);
      return;
    }
    var removeBtn = e.target.closest('[data-clutch-remove]');
    if (removeBtn) {
      e.preventDefault();
      var drop = removeBtn.getAttribute('data-clutch-remove').toUpperCase();
      var keep = currentCodes().filter(function (c) { return c.toUpperCase() !== drop; });
      setMsg('Removing…');
      updateDiscounts(keep).then(function (cart) {
        rerender(cart.sections);
        setMsg('');
      }).catch(function () { setMsg('Couldn’t remove that code. Please try again.', 'error'); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.id === 'ClutchDiscountInput') {
      e.preventDefault();
      var btn = document.querySelector('[data-clutch-apply]');
      if (btn) btn.click();
    }
  });
})();
